import { render, staticRenderFns } from "./CalendarConfirmation.vue?vue&type=template&id=2063891a&scoped=true"
import script from "./CalendarConfirmation.vue?vue&type=script&lang=js"
export * from "./CalendarConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063891a",
  null
  
)

export default component.exports